import React from 'react';
import styled from 'styled-components';
import { useLang } from '../context/LangContext';

// 다국어 텍스트
const demoBannerTexts = {
  ko: {
    message: '⚠️ 시연용 데모 버전입니다. 실제 거래 및 결제는 제공되지 않습니다.'
  },
  en: {
    message: '⚠️ This is a demo version for demonstration purposes. Actual transactions and payments are not provided.'
  }
};

const BannerContainer = styled.div`
  width: 100%;
  background: rgba(255, 152, 0, 0.9); /* 주황색 배경, 90% 불투명도 */
  backdrop-filter: blur(8px); /* 뒷배경 흐림 효과 */
  -webkit-backdrop-filter: blur(8px); /* Safari 호환 */
  border-top: 1px solid rgba(255, 152, 0, 0.3);
`;

const BannerContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 6px 12px;
  }
`;

const MessageText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const DemoBanner: React.FC = () => {
  const { lang } = useLang();
  const texts = demoBannerTexts[lang];

  return (
    <BannerContainer>
      <BannerContent>
        <MessageText>{texts.message}</MessageText>
      </BannerContent>
    </BannerContainer>
  );
};

export default DemoBanner;